module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("vue-parallax-js")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('b', [_vm._v("install via npm")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("in your main javascript file")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('pre', [_vm._v("\n" + _vm._s(_vm.basicUsageExample[0])), _c('span', [_vm._v("0.2")]), _vm._v(_vm._s(_vm.basicUsageExample[1]) + "\n\n"), _vm._m(7), _vm._v("\n"), _vm._m(8), _vm._v("\n"), _vm._m(9), _vm._v("\n\t\t\t")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', [_vm._v("when adding vue-parallax-js to Vue you can pass some options")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('pre', [_vm._v("\n" + _vm._s(_vm.optioExample[0]) + "."), _c('span', [_vm._v("modifier")]), _vm._v(_vm._s(_vm.optioExample[1]) + "\n"), _vm._m(16), _vm._v("\n\t\t\t")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n\t\t\t\tvue component for parallax effect on elements "), _c('br'), _vm._v("\n\t\t\t\tno dependencies "), _c('br'), _vm._v("\n\t\t\t\tlightweight "), _c('br'), _vm._v("\n\t\t\t\t1.6 KB - minified"), _c('br'), _vm._v("\n\t\t\t\tfor "), _c('span', [_vm._v("Vue.js 2")]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Setup "), _c('a', {
    attrs: {
      "href": "#setup",
      "name": "setup"
    }
  }, [_vm._v("~")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_vm._v("\nnpm install --save vue-parallax-js\n"), _c('em', [_vm._v("# or use yarn")]), _vm._v("\n"), _c('em', [_vm._v("# yarn add vue-parallax-js")]), _vm._v("\n\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_vm._v("using "), _c('span', [_vm._v("vue-parallax-js")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_vm._v("\n"), _c('em', [_vm._v("// import Vue and vue-parallax-js")]), _vm._v("\nimport Vue from 'vue'\nimport VueParallaxJs from 'vue-parallax-js'\n\n"), _c('em', [_vm._v("// add vue-parallax-js to vue")]), _vm._v("\nVue.use(VueParallaxJs)\n\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Usage "), _c('a', {
    attrs: {
      "href": "#usage",
      "name": "usage"
    }
  }, [_vm._v("~")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_vm._v("in your templates you can now use the "), _c('span', [_vm._v("v-parallax")]), _vm._v(" directive.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('em', [_c('span', [_vm._v("0")]), _vm._v(" will appear static on the page (no effect)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('em', [_c('span', [_vm._v("1")]), _vm._v(" will move along the page at the same speed as the scrolling")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('em', [_c('span', [_vm._v("-1")]), _vm._v(" will move upwards at the same speed as the scrolling")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Options "), _c('a', {
    attrs: {
      "href": "#options",
      "name": "options"
    }
  }, [_vm._v("~")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_vm._v("\nVue.use(VueParallaxJs, "), _c('span', [_vm._v("{option: value}")]), _vm._v(")\n\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option head"
  }, [_c('div', {
    staticClass: "param"
  }, [_vm._v("option")]), _vm._v(" "), _c('div', {
    staticClass: "type"
  }, [_vm._v("value-type")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "param"
  }, [_vm._v("minWidth")]), _vm._v(" "), _c('div', {
    staticClass: "type"
  }, [_vm._v("integer")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("minumum window width for parallax to take effect")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Modifiers "), _c('a', {
    attrs: {
      "href": "#modifiers",
      "name": "modifiers"
    }
  }, [_vm._v("~")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("when using the "), _c('span', [_vm._v("v-parallax")]), _vm._v(" directive you can also pass some modifiers to configure the instance of vue-parallax-js")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('em', [_vm._v("// notice the "), _c('span', [_vm._v(".")]), _vm._v(" between \"v-parallax\" and the modifier")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option head"
  }, [_c('div', {
    staticClass: "param"
  }, [_vm._v("modifier")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "param"
  }, [_vm._v("centerX")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("will add \"transform: "), _c('em', [_vm._v("translateX(-50%)")]), _vm._v("\" along with the parallax positioning")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "param"
  }, [_vm._v("absY")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("uses the window height instead of the element height for the calculations")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25268710!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content.vue
// module id = 13
// module chunks = 0